import { IonAvatar, IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import React, {useState, useEffect} from 'react'
import Api from "../../services/Api";
import { arrowForward, shareSocial } from 'ionicons/icons';
import { useParams } from 'react-router';

interface ParamTypes {
  teamKey: string
}

interface TeamInterface {
  expired: boolean,
  teamName: string,
  members: Array<MemberInterface>,
  memberCount: number,
  isMember: boolean
}

interface MemberInterface {
  firstName: string
  id: number
  name: string
  picture: string
}

const TeamMembers = () => {
  const api = Api.getInstance()
  const { teamKey } = useParams<ParamTypes>()

  const [data, setData] = useState<Array<MemberInterface>>([]);
  const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);
  const [items, setItems] = useState<string[]>([]);
  const [team, setTeam] = useState<TeamInterface>({
    expired: false,
    teamName: '',
    members: [],
    memberCount: 0,
    isMember: false
  })

  useEffect(() => {
    getTeam()
    setInfiniteDisabled(false);
    setData([])
    // console.log('filter', myWalks, data)

  }, [])

  useEffect(() => {
    // console.log('disable', myWalks, data)
    if(team.members.length < 20) {
      setInfiniteDisabled(true);
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // console.log('push', myWalks, data)
    pushData()

  }, [team.members]) // eslint-disable-line react-hooks/exhaustive-deps


  const getTeam = () => {
    api.get('show_team/' + teamKey).then(res => res.json()).then(data => {
      if(data.status === 'ok') {
        console.log(data)
        setTeam({
          ...team,
          teamName: data.teamName,
          members: data.members,
          memberCount: data.memberCount,
          isMember: data.joined !== null ? true : false,
          expired: data.expired
        })
      }
  })
}

  useEffect(() => {
    // console.log('push', myWalks, data)
    pushData()

  }, [team.members.length !== 0]) // eslint-disable-line react-hooks/exhaustive-deps

  const pushData = () => {
    const max = data.length + 20;
    const min = max - 20;
    const newData = [];
    console.log('push data', team)
    for (let i = min; i < max; i++) {
      if(team.members[i]) {
        newData.push(team.members[i]);
      }
    }

    setData([
      ...data,
      ...newData
    ]);
  }

  const loadData = (ev: any) => {
    setTimeout(() => {
      pushData();

      ev.target.complete();

      if (data.length === team.members.length) {
        setInfiniteDisabled(true);
      }
    }, 500);
  }  
  
  return (
    <IonPage className="cheap_desktop">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>
          <IonTitle>{team.teamName}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          {data.map((obj, index) => (
            <IonItem key={index} routerLink={'/walk/user/profile/' + obj.id}>
              <IonAvatar slot="start">
                <img src={obj.picture} alt="avatar" />
              </IonAvatar>
              <IonLabel className="ml-2">{obj.name}</IonLabel>
              <IonIcon icon={arrowForward}/>
            </IonItem>
          ))}
        </IonList>
        <IonInfiniteScroll
        onIonInfinite={loadData}
        threshold="100px"
        disabled={isInfiniteDisabled}>
        <IonInfiniteScrollContent
          loadingSpinner="bubbles"
          loadingText="Loading more walks..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>

      </IonContent>
    </IonPage>
  )
}

export default TeamMembers;